export default __webpack_public_path__ + "static/location-middle-east-0c3699d7c2ecdbc0b23d6b01ffa84c69.png";